/** Calendarios laborales, en español (#13886). Los usan festivos y centros de trabajo. */
export const CALENDAR_LABELS: Record<string, string> = {
	PALMA: "Palma",
	MADRID: "Madrid",
};
